<div
  class="color-picker-type-container"
  [colorPicker]="color$ | async"
  (colorPickerChange)="onColorPickerChange($event)"
  [style.background]="color$ | async"
  [style.width]="customizableWidthAndHeight ? customizableWidthAndHeight + 'px' : null"
  [style.height]="customizableWidthAndHeight ? customizableWidthAndHeight + 'px' : null"
></div>
